import React from "react";
import { Navigate } from "react-router-dom";
import TripodListPage from "./pages/tripod-list";
import TripodLog from "./pages/tripod-log";
import TripodDailyLog from "./pages/tripod-daily-log";

export const TripodRoutes = [
  { path: "tripods", element: <TripodListPage /> },
  { path: "log/detail-logs", element: <TripodLog /> },
  { path: "log/daily-logs", element: <TripodDailyLog /> },
  
  { path: "*", element: <Navigate to="/tripod/tripods" /> },
];

export default TripodRoutes;
